<template>
  <div class="h-6 w-3 bg-border absolute top-0 bottom-0 left-1/2 -translate-x-1/2 m-auto rounded-sm flex data-[state=hover]:bg-white">
    <UIcon name="i-fa7-solid-grip-lines-vertical" class="size-6 absolute m-auto -translate-x-1/4" />
  </div>
</template>
